<template>
  <div
    class="
      content-wrap
    ">
    <div
      v-for="
        (stat, key) of label
      "
      :key="key"
      class="stat">
      <span
        class="
          stat-label
        ">
        {{ stat }}
      </span>
      <h6
v-if="loader"
        class="
          stat-value
        ">
        <i class="el-icon-loading" />
      </h6>
      <h6
v-else
        class="
          stat-value
        ">
        {{ format(value(key)) }}
      </h6>
    </div>
  </div>
</template>

<script lang="js">

// Client
import { SubscriberReportClient as Client } from '@/clients/BackendAdminClient/subscriber-report'

// Common
import { SubsReportFilterCommon as FilterCommon } from '@/features/subscribers-report/common/subs-report-filter.common'

export default {
  props: {
    filter: {
      type   : Object,
      default: () => FilterCommon.filter()
    }
  },
  data() {
    return {
      loader: true,
      label: {
        users     : 'ผู้ใช้งาน',
        total     : 'รายการสมาชิก',
        subscribed: 'ใช้งานอยู่',
        cancelled : 'ยกเลิกแล้ว'
      },
      summary: null
    }
  },
  watch: {
    filter: {
      deep: true,
      handler() {
        this.fetch()
      }
    }
  },
  created() {
    this.fetch()
  },
  methods: {
    async fetch() {

      // Validate filter
      if (!this.filter) return

      try {
        
        // Loading
        this.loader = true

        // Request Summary
        this.summary = await Client.summary(this.filter)
      }
      catch (error) {
        this.$emit(
          'error', error, 'ไม่สามารถโหลดสรุปยอดได้'
        )
      }
      finally {
        
        // Loaded
        this.loader = false
      }
    },
    value(key) {

      // Validate summary
      if (!this.summary) return null

      // Summary props
      const { subs } = this.summary || {}
      
      // Filter key
      switch(key) {
        
        // User count
        case 'users': {
          return this.summary[key]
        }
        
        // Subsciber stats
        case 'total': 
        case 'cancelled':
        case 'subscribed': {
          return subs[key]
        }
        default: return null
      }
    },
    format(value) {
      return (value ?? 0).toLocaleString()
    }
  }
}

</script>

<style lang="css" scoped>

.content-wrap {
  display              : grid;
  grid-template-columns: repeat(4, 1fr);
  gap                  : var(--size-lg);
  background-color     : white;
}

.stat {
  display       : flex;
  flex-direction: column;
  padding-right : var(--size-lg);
  border-right  : var(--border);
}

.stat {
  flex: 1;
}

.stat:last-child {
  border-right: none;
}

.stat-label {
  font-size: .9rem;
  color    : #909399;
}

.stat-value {
  margin     : 0;
  font-size  : 1.5rem;
  font-weight: bold;
}

@media only screen and (max-width: 768px) {
  .stat {
    border: none;
  }
  .content-wrap {
    grid-template-columns: repeat(2, 1fr);
  }

}

</style>
